// Centralized HMR manager for EventEmitter instances.

import type EventEmitter from 'eventemitter3';

// Registers emitters so we can perform unified cleanup during HMR / page unload.
const registered = new Set<EventEmitter<any>>();

export function registerEmitter(emitter: EventEmitter<any>) {
  registered.add(emitter);
}

export function unregisterEmitter(emitter: EventEmitter<any>) {
  registered.delete(emitter);
}

export function cleanupAllEmitters() {
  for (const e of registered) {
    try {
      e.removeAllListeners();
    } catch (err) {
      // best-effort cleanup; swallow errors to avoid breaking HMR
      // eslint-disable-next-line no-console
      console.warn('[hmr-manager] failed to cleanup emitter', err);
    }
  }
}

// Install HMR and page-unload hooks once when this module is evaluated.
if (typeof window !== 'undefined') {
  try {
    // runtime HMR hooks (Vite)
    // `import.meta.hot` may be undefined in production bundles without HMR.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (import.meta.hot) {
      // @ts-ignore
      import.meta.hot.accept(() => {
        cleanupAllEmitters();
      });

      // @ts-ignore
      import.meta.hot.dispose(() => {
        cleanupAllEmitters();
      });
    }
  } catch (e) {
    // ignore if import.meta.hot is not supported
  }

  // Additional cleanup on normal page unload/navigation
  window.addEventListener('beforeunload', () => {
    cleanupAllEmitters();
  });
}
